import { render, staticRenderFns } from "./ProjectProfitability.vue?vue&type=template&id=188eaaf1&scoped=true"
import script from "./ProjectProfitability.vue?vue&type=script&lang=js"
export * from "./ProjectProfitability.vue?vue&type=script&lang=js"
import style0 from "./ProjectProfitability.vue?vue&type=style&index=0&id=188eaaf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188eaaf1",
  null
  
)

export default component.exports